import { createContext, useContext } from 'react';
export const IconsThemeContext = createContext('base');
export const useIconsTheme = () => {
    const context = useContext(IconsThemeContext);
    return context;
};
//# sourceMappingURL=context.js.map